import React from 'react';
import PropTypes from 'prop-types';
import styles from './AdminMenu.module.css';
import MenuClubList from 'components/navigation/MenuClubList';
import MenuLinkList from 'components/navigation/MenuLinkList';

const AdminMenu = ({ isOpened, closeMenu, selectedClub, clubs }) => {
  return (
    <>
      <div
        className={`${styles.sidebarOverlay} ${isOpened ? styles.show : ''}`}
        onClick={closeMenu}
      />
      <div className={`${styles.sidebar} ${isOpened ? styles.show : ''}`}>
        <div className={styles.sidebarHeader}>
          <MenuClubList selectedClub={selectedClub} clubs={clubs} />
        </div>
        <nav className={styles.sidebarNav}>
          <MenuLinkList closeMenu={closeMenu} />
        </nav>
      </div>
    </>
  );
};

AdminMenu.propTypes = {
  isOpened: PropTypes.bool,
  closeMenu: PropTypes.func,
  selectedClub: PropTypes.object,
  clubs: PropTypes.array,
};

export default AdminMenu;
